(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory();
    } else {
        root.ES6ishClassExtend=factory();
    }
})(this,function(){
    	return function ( target, donor){
    		var key;

    		for( key in donor ){
                if( donor.hasOwnProperty( key ) ){
        			target[key] = donor[key];
                }
    		}
    		return target;
    	}
});
